import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Requested from './requested'
import Accepted from './accepted'
import Rejected from './rejected'
export default function LoansTabs() {
    return (
        <Tabs
            defaultActiveKey="requestedLoan"
            id="fill-tab-example"
            className="mb-3 myLoansTab"
            fill
            variant="underline"
            style={{
                backgroundColor: '#74B743',
                color: '#ffffff',
            }}
        >
            <Tab eventKey="requestedLoan" title="منتظر بررسی">
                <Requested />
            </Tab>
            <Tab eventKey="fullfieldLoans" title="تخصیص داده شده">
                <Accepted />
            </Tab>
            <Tab eventKey="rejectedLoans" title="رد شده">
                <Rejected />
            </Tab>
        </Tabs>
    )
}
